<template>
    <div>
      <div class="col-12 lg:col-12 px-0" v-if="puedeEditar()">
        <Toolbar class="mb-2">
          <template #end>
            <Button
              label="Nuevo"
              icon="pi pi-plus"
              class="p-button-success mr-2"
              @click="showAgregar"
            />
            <!-- <Button v-show="selectTipoReporte && selectTipoReporte.id>0" label="Exportar a Excel" icon="pi pi-download" class="p-button-help" @click="exportar($event)"></Button> -->
          </template>
        </Toolbar>
      </div>
  
      <DataTable
        :value="servidores"
        dataKey="id"
        v-model:expandedRows="expandedRows" ref="dt"
        v-model:filters="filters"
        :loading="loading"
        :scrollabe="true"
        scrollHeight="65vh"
        responsiveLayout="scroll"
        scrollDirection="both"
      >
        <template #header>
          <div class="p-grid flex justify-content-between">
            <h5>Servidores</h5>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                type="text"
                v-model="filters['global'].value"
                placeholder="Buscar..."
              />
            </span>
          </div>
        </template>
        <template #empty> No se encontrarón registros. </template>
        <template #loading> Cargando datos. Espere por favor. </template>
        <Column :expander="true" headerStyle="width: 3rem" />
        <Column field="numunidad" header="Unidad" sortable>
          <template #body="{data}">
            <b>{{ data.numunidad }}</b> {{ data.tipunidad }} {{ data.descunidad }}
          </template>
        </Column>
        <!-- <Column field="tipunidad" header="Tipo de unidad" sortable></Column>
        <Column field="descunidad" header="Descripción" sortable></Column> -->
        <Column field="ip" header="IP" sortable></Column>
        <Column field="sistema" header="Sistema" sortable>
          <template #body="{data}">
              <Button :label="data.sistema" icon="pi pi-external-link" class="p-button-sm" @click="abrirLiga(data.liga)" link/>
              <Button label="Kill Java" icon="pi pi-times-circle" class="p-button-sm" severity="danger" @click="abrirKillJava(data)" text/>
          </template>
        </Column>
        <Column field="titular" header="Titular" sortable>
          <template #body="{data}">
            {{  data.titular }}  
            <span v-if="data.celular"><br><b>Cel:</b> {{ data.celular }}</span>
            <span v-if="data.correo"><br><b>Correo:</b> {{ data.correo }}</span>
          </template>
        </Column>
        <Column field="ip_siais" header="Ip_siais" sortable></Column>
        <Column field="ip_sai" header="Ip_sai" sortable></Column>
        <column field="Tipo_regimen" header="Regimen" sortable></column>
        <Column field="estatus" header="ESTATUS" sortable>
          <template #body="slotProps">
            <span class="status-activo" v-show="slotProps.data.estatus"> ACTIVO </span>
            <span class="status-inactivo" v-show="!slotProps.data.estatus"> INACTIVO </span>
          </template>
        </Column>
        <!-- <Column field="CantidadDisponibles" header="Disponibles" sortable></Column> -->
        <Column v-if="puedeEditar()" :exportable="false">
          <template #body="slotProps">
            <Button
              icon="pi pi-pencil"
              class="p-button-rounded p-button-success"
              @click="edit(slotProps.data)"
            />
            <Button
              style="margin-left: 8px"
              icon="pi pi-times"
              class="p-button-rounded p-button-danger"
              @click="borrar(slotProps.data)"
            />
          </template>
        </Column>

      <template #expansion="slotProps">
        <Card>
          <template #content>
            <div class="grid">
              <div class="col-6">
                <div class="grid">
                  <div class="col title">Usuario SIMF</div>
                  <div class="col data">{{ slotProps.data.usuario_simf_ipicyt }}</div>
                </div>
                <div class="grid">
                  <div class="col title">Usuario SAI</div>
                  <div class="col data">{{ slotProps.data.usuario_sai_ipicyt }}</div>
                </div>
              </div>
              <div class="col-6">
                <div class="grid">
                  <div class="col title">Password SIMF</div>
                  <div class="col data">{{ slotProps.data.password_simf_ipicyt }}</div>
                </div>
                <div class="grid">
                  <div class="col title">Password SAI</div>
                  <div class="col data">{{ slotProps.data.password_sai_ipicyt }}</div>
                </div>
              </div>

              <div class="col-12">
                <div class="grid">
                  <div class="col-3 title">SQL Connection</div>
                  <div class="col-9 data" style="word-break: break-all;">{{ slotProps.data.sqlconnection }}</div>
                </div>
              </div>
            </div>
          </template>
        </Card>
      </template>

        <template #footer>
          Registros en total {{ servidores ? servidores.length : 0 }}
        </template>
      </DataTable>
  
      <Dialog
        :style="{ width: '40vw' }"
        :visible="displayAgregar"
        :modal="true"
        class="p-fluid"
        :closable="false"
      >
        <template #header>
          <h3>{{ modoEdicion }} servidor</h3>
        </template>
        
        <div class="p-formgrid grid">
          <div class="col-12">
            <h5>Datos de la unidad</h5>
          </div>
          <div class="p-field col-3">
            <label for="numunidad">Numero de unidad</label>
            <InputText
              autocomplete="off"
              id="numunidad"
              v-model.trim="servidorSeleccionado.numunidad"
              required="true"
              autofocus
              :class="{ 'p-invalid': submitted && !servidorSeleccionado.numunidad }"
            />
            <small class="p-invalid" v-if="submitted && !servidorSeleccionado.numunidad"
              >Este campo es requerido.</small
            >
          </div>
          <div class="p-field col-3">
            <label for="tipunidad">Tipo de unidad</label>
            <InputText
              autocomplete="off"
              id="tipunidad"
              v-model.trim="servidorSeleccionado.tipunidad"
              required="true"
              autofocus
              :class="{ 'p-invalid': submitted && !servidorSeleccionado.tipunidad }"
            />
            <small class="p-invalid" v-if="submitted && !servidorSeleccionado.tipunidad"
              >Este campo es requerido.</small
            >
          </div>
          <div class="p-field col-6">
            <label for="descunidad">Descripción</label>
            <InputText
              autocomplete="off"
              id="descunidad"
              v-model.trim="servidorSeleccionado.descunidad"
              required="true"
              autofocus
              :class="{ 'p-invalid': submitted && !servidorSeleccionado.descunidad }"
            />
            <small class="p-invalid" v-if="submitted && !servidorSeleccionado.descunidad"
              >Este campo es requerida.</small
            >
          </div>
          <div class="col-12">
            <h5>Datos del servidor</h5>
          </div>
          <div class="p-field col-6">
            <label for="ip">IP</label>
            <InputText
              autocomplete="off"
              id="ip"
              v-model.trim="servidorSeleccionado.ip"
              required="true"
              autofocus
              :class="{ 'p-invalid': submitted && !servidorSeleccionado.ip }"
            />
            <small class="p-invalid" v-if="submitted && !servidorSeleccionado.ip"
              >Este campo es requerido.</small
            >
          </div>
          <div class="p-field col-6">
            <label for="sistema">Sistema</label>
            <InputText
              autocomplete="off"
              id="sistema"
              v-model.trim="servidorSeleccionado.sistema"
              required="true"
              autofocus
              :class="{ 'p-invalid': submitted && !servidorSeleccionado.sistema }"
            />
            <small class="p-invalid" v-if="submitted && !servidorSeleccionado.sistema"
              >Este campo es requerido.</small
            >
          </div>
          <div class="p-field col-6">
            <label for="contra">Contraseña</label>
            <InputText
              autocomplete="off"
              id="contra"
              v-model.trim="servidorSeleccionado.contra"
              required="true"
              autofocus
              :class="{ 'p-invalid': submitted && !servidorSeleccionado.contra }"
            />
            <small class="p-invalid" v-if="submitted && !servidorSeleccionado.contra"
              >Este campo es requerido.</small
            >
          </div>
          <div class="p-field col-6">
            <label for="liga">Liga</label>
            <InputText
              autocomplete="off"
              id="liga"
              v-model.trim="servidorSeleccionado.liga"
              required="true"
              autofocus
              :class="{ 'p-invalid': submitted && !servidorSeleccionado.liga }"
            />
            <small class="p-invalid" v-if="submitted && !servidorSeleccionado.liga"
              >Este campo es requerido.</small
            >
          </div>
          <div class="col-12">
            <h5>Datos del titular</h5>
          </div>
          <div class="p-field col-6">
            <label for="titular">Nombre</label>
            <InputText
              autocomplete="off"
              id="titular"
              v-model.trim="servidorSeleccionado.titular"
              required="true"
              autofocus
              :class="{ 'p-invalid': submitted && !servidorSeleccionado.titular }"
            />
            <small class="p-invalid" v-if="submitted && !servidorSeleccionado.titular"
              >Este campo es requerido.</small
            >
          </div>
          <div class="p-field col-6">
            <label for="correo">Correo institucional</label>
            <InputText
              autocomplete="off"
              id="correo"
              v-model.trim="servidorSeleccionado.correo"
              required="true"
              autofocus
              :class="{ 'p-invalid': submitted && !servidorSeleccionado.correo }"
            />
            <small class="p-invalid" v-if="submitted && !servidorSeleccionado.correo"
              >Este campo es requerido.</small
            >
          </div>
          <div class="p-field col-6">
            <label for="celular">Telefono celular</label>
            <InputText
              autocomplete="off"
              id="celular"
              v-model.trim="servidorSeleccionado.celular"
              required="true"
              autofocus
              :class="{ 'p-invalid': submitted && !servidorSeleccionado.celular }"
            />
            <small class="p-invalid" v-if="submitted && !servidorSeleccionado.celular"
              >Este campo es requerido.</small
            >
          </div>
          <div class="col-12">
            <h5>Datos de conexion</h5>
          </div>
          <div class="p-field col-6">
            <label for="sqlconnection">SQL connection</label>
            <InputText
              autocomplete="off"
              id="sqlconnection"
              v-model.trim="servidorSeleccionado.sqlconnection"
              aria-required="true"
              autofocus
              :class="{ 'p-invalid': submitted && !servidorSeleccionado.sqlconnection }"
            />
            <small class="p-invalid" v-if="submitted && !servidorSeleccionado.sqlconnection"
              >Este campo es requerido.</small
            >
          </div>
          <div class="p-field col-6">
            <label for="ip_siais">Ip siais</label>
            <InputText
              autocomplete="off"
              id="ip_siais"
              v-model.trim="servidorSeleccionado.ip_siais"
              aria-required="true"
              @keypress="soloNumerosYPuntos($event)" 
            />
          </div>
          <div class="p-field col-6">
            <label for="ip_sai">Ip sai</label>
            <InputText
              autocomplete="off"
              id="ip_sai"
              v-model.trim="servidorSeleccionado.ip_sai"
              aria-required="true"
              @keypress="soloNumerosYPuntos($event)"
            />
          </div>
          <div class="p-field col-6">
            <label for="Tipo_regimen">Tipo de regimen</label>
            <Dropdown
              id="Tipo_regimen"
              appendTo="body"
              v-model="servidorSeleccionado.Tipo_regimen"
              :filter="true"
              :options="Tipos_Regimenes"
              optionLabel="Descripcion"
              optionValue="Descripcion"
              placeholder="Selecciona un regimen"
              :class="{ 'p-invalid': submitted && !servidorSeleccionado.Tipo_regimen }"
            />
          </div>
          <div class="col-12">
            <h5> SIMF ipicyt</h5>
          </div>
          <div class="p-field col-6">
            <label for="usuario_simf_ipicyt">Usuario</label>
            <InputText
              autocomplete="off"
              id="usuario_simf_ipicyt"
              v-model.trim="servidorSeleccionado.usuario_simf_ipicyt"
              aria-required="true"
            />
          </div>
          <div class="p-field col-6">
            <label for="password_simf_ipicyt">Password</label>
            <InputText
              autocomplete="off"
              id="password_simf_ipicyt"
              v-model.trim="servidorSeleccionado.password_simf_ipicyt"
              aria-required="true"
            />
          </div>
          <div class="col-12">
            <h5> Sai ipicyt</h5>
          </div>
          <div class="p-field col-6"> 
            <label for="usuario_sai_ipicyt">Usuario</label>
            <InputText
              autocomplete="off"
              id="usuario_sai_ipicyt"
              v-model.trim="servidorSeleccionado.usuario_sai_ipicyt"
              aria-required="true"
            />
          </div>
          <div class="p-field col-6">
            <label for="password_sai_ipicyt">Password</label>
            <InputText
              autocomplete="off"
              id="password_sai_ipicyt"
              v-model.trim="servidorSeleccionado.password_sai_ipicyt"
              aria-required="true"
            />
          </div>
        </div>
  
        <div class="p-formgrid grid">
          <div class="p-field col">
            <div class="p-field-checkbox">
              <Checkbox
                id="Activo"
                name="Activo"
                :binary="true"
                v-model="servidorSeleccionado.estatus"
              />
              <label for="Activo"> Activo</label>
            </div>
          </div>
          <div class="col-12">
          </div>
        </div>
        <template #footer>
          <Button
            label="Cancelar"
            icon="pi pi-times"
            class="p-button-text"
            @click="cancelarDialogo"
          />
          <Button
            label="Guardar"
            icon="pi pi-check"
            class="p-button-text"
            @click="guardarRegistro"
          />
        </template>
      </Dialog>
  
    </div>
    <ConfirmDialog></ConfirmDialog>
  </template>
  
  <script>
  import Servidores from "../../service/monitoreo/Servidores";
  import DirectorioUnidad from "../../service/DirectorioUnidad";
  import { FilterMatchMode } from "primevue/api";
  import Utilerias from "../../utilidades/Utilerias";
  export default {
    data() {
      return {
        lstUnidades: [],
        servidores: null,
        Tipos_Regimenes: null,
        expandedRows: [],
        filters: {
          global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        },
        filter: null,
        loading: true,
        submitted: false,
        displayAgregar: false,
        modoEdicion: "",
        servidorSeleccionado: {},
      };
    },
    created() {
      this.getServidores();
      this.getRegimen ();
    },
    methods: {
      abrirKillJava(obj){
        var t= this;
        t.$confirm.require({
            message: '¿Está seguro que desea resetear el servidor?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              var servidoresService = new Servidores();
              servidoresService.KillJava(t, obj.id).then((res) => {
                console.log(res);
                if(res){
                  t.$toast.add({
                    severity: "success",
                    summary: "AVISO",
                    detail: "Java detenido en el servidor",
                    life: 3000,
                  });
                }
                else{
                  t.$toast.add({
                    severity: "warn",
                    summary: "AVISO",
                    detail: "No se detuvo el servicio",
                    life: 3000,
                  });
                }
              });              
            },
            reject: () => {
            }
          });
      },
      getServidores() {
        var t = this;
        var servidoresService = new Servidores();
        t.loading = true;
  
        servidoresService.GetAll(t)
          .then((res) => {
            t.servidores = res; //res.filter((item) => item.Activo);
            t.loading = false;
          })
          .catch(function (error) {
            console.error("Error:", error);
            t.loading = false;
          });
      },
      getRegimen(){
        var t = this;
        var regimenesService = new DirectorioUnidad();
        t.loading = true;
  
        regimenesService.getTiposRegimenesActivos(t)
          .then((res) => {
            t.Tipos_Regimenes = res;
            t.loading = false;
          })
          .catch(function (error) {
            console.error("Error:", error);
            t.loading = false;
          });
      },
      
      esSoloNumerosYPuntos(texto) {
        if (!texto || texto.trim() === '') {
            return true; 
        }
        const regex = /^[0-9.]*$/; 
        return regex.test(texto);
      },

      showAgregar() {
        this.servidorSeleccionado = {estatus: true, liga: 'http://' };
        this.submitted = false;
        this.displayAgregar = true;
        this.modoEdicion = "Agregar";
        this.servidorSeleccionado.Descripcion = "";
      },
      cancelarDialogo() {
        this.submitted = false;
        this.displayAgregar = false;
        this.modoEdicion = "";
        this.servidorSeleccionado = {estatus: true};
      },
      edit(obj) {
        this.servidorSeleccionado = { ...obj };
        this.displayAgregar = true;
        this.modoEdicion = "Editar";
      },
      borrar(obj) {
        var t = this;      
        t.$confirm.require({
            message: '¿Está seguro que desea eliminar este registro?',
            header: 'Confirmacion',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              var servidoresService = new Servidores();
              servidoresService.Delete(t, obj.id).then(() => {
                t.$toast.add({
                  severity: "success",
                  summary: "AVISO",
                  detail: "Insumo eliminado correctamente",
                  life: 3000,
                });
                t.getServidores();
              });
            },
            reject: () => {
            }
        });
      },
      abrirLiga(url){
        window.open(url, '_blank');
      },
      guardarRegistro() {
        var t = this;
        t.submitted = true;

        if (!t.esSoloNumerosYPuntos(t.servidorSeleccionado.ip_siais) || 
            !t.esSoloNumerosYPuntos(t.servidorSeleccionado.ip_sai)||
            !t.esSoloNumerosYPuntos(t.servidorSeleccionado.ip)
        ) {
            t.$toast.add({
                severity: "warn",
                summary: "Caracteres Inválidos",
                detail: "Los campos de IP solo pueden contener números y puntos.",
                life: 3000,
            });
            return; 
        }

        if (
          !t.servidorSeleccionado ||
          !t.servidorSeleccionado.numunidad ||
          !t.servidorSeleccionado.tipunidad ||
          !t.servidorSeleccionado.descunidad ||
          !t.servidorSeleccionado.ip ||
          !t.servidorSeleccionado.sistema ||
          !t.servidorSeleccionado.contra ||
          !t.servidorSeleccionado.liga ||
          !t.servidorSeleccionado.titular ||
          !t.servidorSeleccionado.correo ||
          !t.servidorSeleccionado.celular ||
          !t.servidorSeleccionado.sqlconnection ||
          !t.servidorSeleccionado.Tipo_regimen
        ) {
          return;
        }
  
        let obj = {
          ...t.servidorSeleccionado
        };
        var servidoresService = new Servidores();
        if (obj.id) {
          servidoresService.Update(t, obj).then(() => {
            t.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "Insumo editado correctamente",
              life: 3000,
            });
            t.cancelarDialogo();
            t.getServidores();
          });
        } else {
          servidoresService.Add(t, obj).then(() => {
            t.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "Insumo agregado correctamente",
              life: 3000,
            });
            t.cancelarDialogo();
            t.getServidores();
          });
        }
      },
      puedeEditar(){
          let util = new Utilerias();
          return util.isPermiso("EDITOR_CATALOGOS") == true || util.isAdmin();
      }
    },
    computed:{
    },       
  };
  </script>

<style scoped>
.title {
  font-weight: 700;
  letter-spacing: 0.3px;
  margin-right: 10px;
  text-transform: uppercase;
}
.data {
  letter-spacing: 0.5px;
  margin-right: 10px;
}
</style>